import React from "react";

import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";

function KpkTimeline() {
  return (
    <div>
      <h2 className="text-h-orange">
        “Jails were made for the natives by the British, and there needs to be a
        difference in how we and the former imperial rulers treated our people.”
      </h2>
      <p>- Bait Ullah Khan, DSP Peshawar Central Jail</p>
      <div className="voice-sect">
        <div className="voice-sect-style">
          <p className="mt-5">
            There are a total of 38 prison facilities in Khyber Pakhtunkhwa,
            including six central prisons, eight district prisons, and nine
            sub-jails. According to one study, over half of these were built
            under the colonial administration, including the central prisons of
            Peshawar, Haripur, and Mardan, among others. These figures exclude
            the internment centres that can be found across Khyber Pakhtunkhwa
            and erstwhile FATA, totalling 47, about which little is known, as
            they were controlled by the armed forces until 2019. Until that
            time, they were used to detain suspected terrorists – linked to the
            TTP – captured in military operations dating to 2005.
          </p>
        </div>
        <div className="voice-sect-style">
          <p className="mt-5">
            Despite the existence of two separate systems of incarceration – for
            terrorists and criminals – across the region that has seen much
            turmoil post-9/11, the province and the frontier have been bound
            together in an ongoing struggle defending the tribal belt against an
            unstable Afghanistan. This serves as a throwback to the times when
            Khyber Pakhtunkhwa – then the Northwest Frontier Province – served
            as the administrative centre of British imperial expeditions into
            that country.
          </p>
        </div>
        <div className="voice-sect-style">
          <p className="mt-5" style={{ fontWeight: "bold" }}>
            Ujjwal Singh has{" "}
            <a href="https://eprints.soas.ac.uk/29435/1/10731591.pdf">
              documented
            </a>{" "}
            how the Khyber Pakhtunkhwa central jails, such as the one in
            Haripur, were used to jail anti-colonial political prisoners:
          </p>
        </div>
        <div className="voice-sect-style text-center">
          <img
            style={{ width: "100%", height: "100%" }}
            src={require("../../assets/images/ujjwal.png")}
            alt="ujjwal"
          />
        </div>
      </div>
    </div>
  );
}

export default KpkTimeline;
